import { useDispatch, useSelector } from 'react-redux';
import { State } from '../../../../reducers';

import PlusWhiteIcon from '../../../../media/white_plus-small_icon.svg';
import Edit from '../../../../media/felsv/DarkEditPencil.svg'
import Recycle from '../../../../media/felsv/DarkRecycleDelete.svg'
import Open_Eye from '../../../../media/felsv/Open_Eye.svg'
import Close_Eye from '../../../../media/felsv/Close_Eye.svg'

import { useEffect, useState } from 'react';
import { actionsGUEstadoDocumentos } from '../../../../actions/action-creators';
import { bindActionCreators } from 'redux';
import { Tooltip } from '../../../../components/Tooltip/Tooltip';
import { Pagination } from '../../../../components/Pagination';
import { generalOpenModalInfo } from '../../../../actions/general.actions';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton';

export const Documentos = () => {
  const dispatch = useDispatch();
  const acciones = bindActionCreators(actionsGUEstadoDocumentos, dispatch);

  const {dataDocumentos, dataSucursales} = useSelector((state: State) => state.gestionUsuario.sucursales);
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos);
  const [currentDocumentos, setCurrentDocumentos] = useState<Array<any>>([]);
  const [sortedDocumentos, setSortedDocumentos] = useState<Array<any>>([])

  useEffect(() => {
    obtenerDocumentos();
  }, []);

  useEffect(() => {
    setSortedDocumentos(dataDocumentos.map((doc) => ({
      ...doc,
      filter_sucursal: dataSucursales.find(suc => suc.idsucursal === doc.idsucursal)?.nombre,
      filter_documento: tipoDocumentosEmision.find(docEmi => docEmi.iddocumento === doc.iddocumento)?.descripcion,
    })))
  }, [dataDocumentos])

  const obtenerDocumentos = () => {
    acciones.su_getDocumentosSucursalesList();
  }

  const handleChangeEstatus = (documento: any, accion: boolean) => {
    const sucursal = dataSucursales.find(suc => suc.idsucursal === documento.idsucursal);
    if (!sucursal.activo) {
      dispatch(
        generalOpenModalInfo(`Acción no permitida, la sucursal asociada se encuentra desactivada.`)
      )
      return;
    }
    acciones.gu_ed_SetDocumentoSeleccionado({...documento, accion, title: 'documento'});
    acciones.gu_ed_ShowModalChangeEstatus(true);
  }

  const handleAdd = () => {
    acciones.su_ClearFormDocSucursal();
    acciones.gu_ed_ShowModalCrearEditarSucursalDocumento(true);
  }
  
  const handleEdit = (documento: any) => {
    acciones.su_setFormDocSucursal({
      ...documento, mode:"edit", 
      documento: documento.iddocumento,
      codigoSucursal: documento.serie.substring(0, 4),
      numeroSucursal: documento.serie.substring(4, 8),
    });
    acciones.gu_ed_SetDocumentoSeleccionado(documento);
    acciones.gu_ed_ShowModalCrearEditarSucursalDocumento(true);
  }

  const handleDelete = (documento: any) => {
    acciones.gu_ed_SetDocumentoSeleccionado({...documento, title: "documento"});
    acciones.gu_ed_ShowModalEliminarDocumento(true)
  }

  return (
    <div className='container-white w-100'>
      <div className='card-basic w-100 mt-16'>
        <div className='mb-16'>
          <h3 className='card-title l mb-16'>Documentos</h3>
          <div className='w-100 flex-align-end'>
            <button 
              className='m button w-auto' 
              style={{display: 'right'}} 
              onClick={handleAdd}
            >
              {
                (<>
                  <img src={PlusWhiteIcon} loading='lazy' alt=''/>
                  <div>{'Agregar documento'}</div>
                </>)
              }
            </button>
          </div>
          <div className='separador' style={{opacity: '10%', marginTop: '16px'}}></div>
        </div>
        <div>
          <div className='tab-plane' style={{overflowY:'scroll'}}>
            <table className='table-main-responsive responsive-table-main td-left table-pointer'>
              <thead>
                <tr>
                  <td>Nombre de sucursal <FilterButton keyName='filter_sucursal' data={sortedDocumentos} state={(items: Array<any>) => setSortedDocumentos(items)}/></td>
                  <td>Documento <FilterButton keyName='filter_documento' data={sortedDocumentos} state={(items: Array<any>) => setSortedDocumentos(items)}/></td>
                  <td>Serie <FilterButton keyName='serie' data={sortedDocumentos} state={(items: Array<any>) => setSortedDocumentos(items)}/></td>
                  <td>Número actual <FilterButton keyName='numeroactual' data={sortedDocumentos} state={(items: Array<any>) => setSortedDocumentos(items)}/></td>
                  <td>Resolución <FilterButton keyName='resolucion' data={sortedDocumentos} state={(items: Array<any>) => setSortedDocumentos(items)}/></td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {
                  currentDocumentos.map((doc, index) => (
                    <tr key={index} style={{opacity: (!doc.estado ? '0.5' : '1')}}>
                      <td data-label='Sucursal'>{dataSucursales.find(suc => suc.idsucursal === doc.idsucursal)?.nombre}</td>
                      <td data-label='Documento'>{tipoDocumentosEmision.find(docEmi => docEmi.iddocumento === doc.iddocumento)?.descripcion}</td>
                      <td data-label='Serie'>{doc.serie}</td>
                      <td data-label='Número actual'>{parseInt(doc.numeroactual)}</td>
                      <td data-label='Resolución'>{doc.resolucion}</td>
                      <td data-label='Acciones' className='table-td'>
                        <Tooltip content={doc.estado ? 'Desactivar' : 'Activar'}>
                          <button className='table-action' onClick={() => handleChangeEstatus(doc, !doc.estado)}>
                            <img src={doc.estado ? Open_Eye : Close_Eye} alt={doc.estado ? 'Desactivar' : 'Activar'} className='table-img-action' />
                          </button>
                        </Tooltip>
                        {
                          (parseInt(doc.numeroactual) <= parseInt(doc.numeroinicial)) &&
                          <Tooltip content='Editar'>
                            <button className='table-action' onClick={() => handleEdit(doc)}>
                              <img src={Edit} alt='Editar' className='table-img-action' />
                            </button>
                          </Tooltip>
                        }
                        {
                          doc.eliminar &&
                            <Tooltip content='Eliminar'>
                              <button className='table-action' onClick={() => handleDelete(doc)}>
                                <img src={Recycle} alt='Eliminar Usuario' className='table-img-action' />
                              </button>
                            </Tooltip>
                        }
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            <Pagination data={sortedDocumentos} state={(items: Array<any>) => setCurrentDocumentos(items)} items={10} />
          </div>
        </div> 
      </div>
    </div>
  )
}
